import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CommonModule } from "uca-react-containers-library";
import reportAccessibility from './utils/report-accessibility';
// import banners from './banners';

let bannerInContext = document.getElementById("banner").dataset.banner;
const environmentIncontext = document.getElementById("env").dataset.env;
const isBusinessBanner = document.getElementById("isBusinessBanner").dataset.isbusinessbanner;
const availableTribes = document.getElementById("available-tribes").dataset.availabletribesdata;

// function resolveBanner(hostname) {
//   if (hostname !== "localhost") {
//     for (let i = 0; i < banners.length; i++) {
//       const regex = new RegExp(banners[i]);
//       if (regex.test(hostname)) {
//         return banners[i];
//       }
//     }
//   }
//   return "vons";
// }

// if(window?.location?.pathname.includes("/account-reset"))
// {
//   bannerInContext = resolveBanner(window?.location?.hostname);
//   const faviconElement = document.getElementById("app-favicon");

//   if (faviconElement) {
//     faviconElement.href = faviconElement.href.replace(/[^/]+\.ico$/, `${bannerInContext}.ico`);
//   }
// }

const appData = {
  banner: bannerInContext,
  env: environmentIncontext,
  isBusinessBanner: isBusinessBanner === "true",
  platform: "web",
  applicationName: "Unified Customer Account",
  availableTribes: (availableTribes && availableTribes !== "AVAILABLE_TRIBES_DATA" && JSON.parse(availableTribes)) || [],
  serverID: window?.SWY.CONFIGSERVICE?.oktaConfig.thirdPartyOauth2ServerId
};

ReactDOM.render(
  <React.StrictMode>
      <CommonModule.AppProvider appData={appData}>     
          <App />
      </CommonModule.AppProvider>
  </React.StrictMode>,
  document.getElementById('uca-root')
);

reportAccessibility(React);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
